import { selectIsLebtHotelLoyaltyEnabled } from 'businessTraveller/selectors/selectIsLebtHotelLoyaltyEnabled'
import { selectIsLebtSabreHotelsEnabled } from 'businessTraveller/selectors/selectIsLebtSabreHotelsEnabled'
import { LE_CONTRACTED_HOTEL_TYPES, OFFER_TYPE_BED_BANK } from 'constants/offer'
import { SEARCH_STREAMING_PAGE_SIZE } from 'search/initialiseSearchSocket'
import config from 'constants/config'
import { fetchAccumulatedRatesForBedbankOffer } from './BedbankOfferActions'
import { AppAction } from './types/ActionTypes'

// Run when search results arrive, before tiles mount, even if summaries are cached.
export default function prefetchSearchTileBedbankRates(
  offerIds: Array<string>,
  metaData: Array<App.OfferListMetaData | undefined>,
  filters: App.OfferListFilters,
): AppAction {
  return (dispatch, getState) => {
    if (IS_SSR || !filters.checkIn || !filters.checkOut) return

    const state = getState()
    if (!selectIsLebtHotelLoyaltyEnabled(state) || !selectIsLebtSabreHotelsEnabled(state)) return

    const firstOfferIds = [...new Set(offerIds)].slice(0, Math.min(SEARCH_STREAMING_PAGE_SIZE, filters.limit ?? SEARCH_STREAMING_PAGE_SIZE))
    for (const offerId of firstOfferIds) {
      const metadata = metaData.find(result => result?.offerId === offerId)
      if (!metadata?.available || metadata.hidePricing) continue

      const isBedbankOffer = metadata.type === OFFER_TYPE_BED_BANK
      const isHotelWithBedbankRate = LE_CONTRACTED_HOTEL_TYPES.some(type => type === metadata.type) &&
        metadata.pricing.rateType === 'bedbank'
      const bedbankOfferId = isBedbankOffer ? offerId :
        isHotelWithBedbankRate ? metadata.pricing.ratePropertyId : undefined
      const rooms = isBedbankOffer ? filters.rooms ?? [config.search.defaultOccupants] : filters.rooms

      if (bedbankOfferId && rooms?.length) {
        // Reuse the tile's batching and cache/in-flight guards; filters alone need no refresh.
        dispatch(fetchAccumulatedRatesForBedbankOffer(bedbankOfferId, rooms, filters.checkIn, filters.checkOut))
      }
    }
  }
}
